export default __webpack_public_path__ + "static/media/guide_045.d4f8575d.md";